"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginBackButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_1 = __importDefault(require("@emotion/styled"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = require("@components/base/Button");
var StyledLoginBackButton = (0, styled_1.default)(Button_1.ButtonLarge)(function () { return ({
    width: "100%",
    fontSize: "16px",
    fontWeight: "500",
    marginTop: "24px",
    display: "inline-flex",
    padding: "11px 24px 11px 12px",
    background: "transparent",
    border: "solid 2px #39546C66",
    color: "#39546C",
    gap: "4px",
    lineHeight: "140%",
    "&:hover": {
        background: "rgba(57, 84, 108, 0.05)",
        border: "2px solid #39546C",
        color: "#39546C",
    },
}); });
var clickHandler = function () {
    location.href = "/admin/auth/login";
};
var LoginBackButton = function () {
    return ((0, jsx_runtime_1.jsx)(Box_1.default, { children: (0, jsx_runtime_1.jsx)(StyledLoginBackButton, { "data-testid": "closeButton", disabled: false, type: "button", onClick: clickHandler, children: "\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u306B\u623B\u308B" }) }));
};
exports.LoginBackButton = LoginBackButton;
